import updateUser from "../users/updateUser";
import { updateInterestedCount } from "./updateCount";
import getAllProperties from "./getAllProperties";
import { webStore } from "store";


export default function shortlistProperty(uuid: any, interested_count: number) {
    return new Promise(async (resolve, reject) => {
        try {
            const userData: any = webStore.getState().auth?.user;
            const userProfile: any = userData?.profile;
            const shortlistedProperties: any = userData?.profile?.meta?.shortlisted_properties;
            const data: any = shortlistedProperties ? shortlistedProperties : [];

            let payload: any = [];
            const propertyData: any = await getAllProperties({
                apiConfig: {
                    includeRelations: [],
                    includeMutations: [],
                    includeFacets: false,
                },
                limitBy: {
                    per_page: 1,
                    page: 1,
                },
                sortBy: [],
                filterBy: [
                    {
                        attribute: "uuid",
                        op: "eq",
                        value: uuid,
                    },
                ],
            });

            let count: number = propertyData.data[0].interested_count;

            if (shortlistedProperties && shortlistedProperties.includes(uuid)) {
                payload = data.filter((item: any) => item !== uuid && item !== null);
                if (count <= 0) {
                    count = 0;
                } else {
                    count = count - 1;
                }
            } else {
                payload = [...data, ...[uuid]];

                if (count < 0) {
                    count = 1;
                } else {
                    count = count + 1;
                }
            }
            await updateUser({
                profile_picture: userProfile?.profile_picture,
                bio: userProfile?.bio,
                meta: {
                    shortlisted_properties: payload,
                },
            });

            const updatedData: any = await updateInterestedCount({ uuid: uuid, count: count });
            resolve({ interested_count: updatedData.interested_count })
        } catch (error) {
            reject(error)
        }
    });
}